import { createI18n } from 'vue-i18n'
import { messages } from './plugins/translations'

//Create VueI18n instance with options
export const i18n = createI18n({
  locale: 'de',           // set locale
  allowComposition: true, // you need to specify that!
  globalInjection: true,
  messages                // set messages 
})
